<template>
  <div v-if="switchPage === 2">
    <Item isArrow iconName="el-icon-arrow-left" :isCheckbox="false" :isEndLine="true" :data="{name: treeName, page: 0}"
      @onClick="handleSwitchTree" />
    <TreeOrg v-if="treeType === 0" :count="orgCount" :selectList="selectList" @onToggle="handleToggle"
      @onAll="handleAll" :home="currentTenant" :isHeadimg="isHeadimg" :shortcutItem="shortcutItem" />
    <TreeRole v-if="treeType === 1" :count="roleCount" :selectList="selectList" @onToggle="handleToggle"
      @onAll="handleAll" :home="currentTenant" :isHeadimg="isHeadimg" />
  </div>
  <div v-else>
    <Item :isCheckbox="false" :isEndLine="true" :data="{name: currentTenant.name}" />
    <Item isArrow :isCheckbox="false" :isEndLine="true" :data="{name: orgName[0], page: 2, treeType: 0}"
      @onClick="handleSwitchTree" />
    <Item isArrow :isCheckbox="false" :isEndLine="true" :data="{name: orgName[1], page: 2,  treeType: 1}"
      @onClick="handleSwitchTree" />
    <Item isArrow :isDown="false" :isCheckbox="false" :isEndLine="true" v-for="org in orgList" :key="org.id" :data="org"
      @onClick="handleShortcut" />
  </div>
</template>

<script>
import Item from './item'
const orgName = ['按组织架构选择', '按角色选择']
import currentTenant from './mixins/currentTenant'
export default {
  mixins: [currentTenant],
  components: {
    TreeOrg: () => import('./TreeOrg'),
    TreeRole: () => import('./TreeRole'),
    Item
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isHeadimg: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      switchPage: 0,
      treeName: '',
      treeType: 0,
      orgName,
      nav: orgName[0],
      orgCount: {},
      roleCount: {},
      shortcutItem: null
    }
  },
  methods: {
    handleBack() {
      this.isNav = true
    },
    handleSwitchTree(item) {
      const {
        page,
        name,
        treeType
      } = item
      this.switchPage = page
      if (page === 2) {
        this.treeName = name
        this.treeType = treeType
      }
      this.shortcutItem = null
    },
    handleShortcut(item) {
      this.switchPage = 2
      this.treeName = orgName[0]
      this.shortcutItem = item
    },
    handleSelect(items, ids) {
      this.$emit('onChecked', items)
    },
    handleAll(allItems, checkAll) {
      this.$emit('onAll', allItems, checkAll)
    },
    handleToggle(item) {
      this.$emit('onToggle', item)
    }
  }
}
</script>

<style lang='scss' scoped>
:deep(.el-submenu__title, .el-submenu.is-active .el-submenu__title) {
  border-bottom: 1px solid #ebeef5;
}
.nav {
  height: 56px;
  display: flex;
  align-items: center;
}
.el-icon-arrow-left {
  padding-left: 20px;
  cursor: pointer;
}
.title {
  padding-left: 10px;
  cursor: pointer;
}
</style>
